import React from 'react';
import { useTranslation } from 'react-i18next';
import { CopyToClipboardButton } from 'components/CopyToClipboardButton';

const CopyReferenceButton = ({ referenceNumber }: { referenceNumber?: string }) => {
  const { t } = useTranslation();

  if (!referenceNumber) {
    return null;
  }

  return (
    <CopyToClipboardButton
      textToCopy={referenceNumber}
      message={t(
        'catalog.reference_card.reference_number.copied_to_clipboard',
        'Reference number {{referenceNumber}} copied to clipboard',
        { referenceNumber },
      )}
      tooltip={t('catalog.reference_card.reference_number.copy', 'Copy reference')}
    />
  );
};

export default CopyReferenceButton;
